import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-received-purchase-order-list',
  templateUrl: './received-purchase-order-list.component.html',
  styleUrls: ['./received-purchase-order-list.component.css']
})
export class ReceivedPurchaseOrderListComponent implements OnInit {
  loading = true;
  busyId: number | null = null;
  orders: any[] = [];

  constructor(
    private apiService: ApiService,
    private toastr: ToastrMsgService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.fetch();
  }

  fetch(): void {
    this.apiService.listReceivedPurchaseOrders().subscribe({
      next: (res: any) => {
        this.loading = false;
        this.orders = res?.data || [];
      },
      error: (err) => {
        this.loading = false;
        this.toastr.error(err.error?.message || 'Failed to load purchase orders');
      }
    });
  }

  formatCurrency(amount: number | string): string {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR'
    }).format(Number(amount) || 0);
  }

  status(po: any): string {
    return String(po?.po_status || 'draft').toLowerCase();
  }

  canRespond(po: any): boolean {
    return this.status(po) === 'issued';
  }

  viewPo(po: any): void {
    this.router.navigate(['/home/received-purchase-orders', po.id]);
  }

  accept(po: any, event: Event): void {
    event.stopPropagation();
    this.run(po.id, () => this.apiService.acceptPurchaseOrder(po.id), 'Purchase order accepted');
  }

  reject(po: any, event: Event): void {
    event.stopPropagation();
    this.run(po.id, () => this.apiService.rejectPurchaseOrder(po.id), 'Purchase order rejected');
  }

  private run(id: number, request: () => any, success: string): void {
    if (this.busyId) return;
    this.busyId = id;
    request().subscribe({
      next: (res: any) => {
        this.busyId = null;
        this.toastr.success(res?.message || success);
        this.fetch();
      },
      error: (err: any) => {
        this.busyId = null;
        this.toastr.error(err?.error?.message || err?.error?.error || 'Action failed');
      }
    });
  }
}
